<template>
  <div class="mypage-layout">
    <header-component></header-component>
    <main class="hierar- -mypage-" :class="mainClass">
      <div class="st- -wrapper">
        <div class="inner- -layer-1 -wrapper">
          
          <div class="st- -page">
            <div class="inner- -layer-2 -page">
              <!-- breadcrumbs end -->
              <hr class="st- -invisible">
              <div id="contents" class="st- -contents">
                <div class="inner- -layer-3 -contents">
                  <slot></slot>
                </div>
              </div>
              <!-- contents end -->
            </div>
          </div>
          <!-- page end -->
        </div>
      </div>
      <!-- wrapper end -->
    </main>
    
    <footer-component></footer-component>
  </div>
</template>

<script>
import HeaderComponent from "../HeaderComponent";
import FooterComponent from "../FooterComponent";

export default {
  // これで無理やり適用するcssを変更する。大本のcssの作りが頭悪い気がする。
  props: ["mainClass"],
  components: {
    HeaderComponent,
    FooterComponent
  }
};
</script>

<style lang="scss">

// 以下で無理やり上書きする。
div.mypage-layout {
  // @import "../../assets/mypage/css/reset";
  // @import "../../assets/mypage/css/style.css";
  // @import "../../assets/mypage/css/style_main.css";
  @import "../../assets/mypage/css/style_struct";
  .st-.-main {
    width: auto !important;
    max-width: 800px !important;
    flex-shrink: 1 !important;
  }

  .hierar-.-mypage- .inner-.-main {
    // max-width: 800px !important;
    padding-top: 60px !important;
  }

  .st-.-wrapper {
    width: 100% !important;
    min-width: 0 !important;
  }

  .inner-.-layer-3.-contents {
    width: 100% !important;
  }

  .hierar-.-mypage- .inner-.-contents {
    justify-content: center !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/mypage/MypageLayout.vue